require('../../../modules/es.function.bind');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Function').bind;